module.exports = __webpack_public_path__ + "img/2-quad.bf69205f.png";